var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cohorts-card__content"},[(_vm.catalogueTitle)?_c('TextTitle',{attrs:{"size":"s"}},[_vm._v(_vm._s(_vm.catalogueTitle)+" ")]):_vm._e(),_vm._l((_vm.lines),function(line,index){return _c('div',{key:index},[_c('strong',[_vm._v(_vm._s(_vm.fields[index])+" :")]),_vm._v(" "+_vm._s(Object.values(line)[0]))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }